import SmsNumber from '@/classes/SmsNumber';

const setUser = ({ commit }, user) => {
  const { userId, token, userName, numbers, activeNumber } = user;
  if (userId && token) {
    commit('setUserId', userId);
    commit('setToken', token);
  } else {
    console.warn('Unable to setUser() without userId & token');
  }
  if (userName) {
    commit('setUserName', userName);
  }
  if (numbers) {
    commit('setNumbers', numbers.map(num => new SmsNumber(num)));
  }
  if (activeNumber) {
    commit('setActiveNumber', new SmsNumber(activeNumber));
  }
};

const updateUser = ({ commit, state }, user) => {
  const { contacts, id, accountId, firstName, lastName, email, enterpriseId, numbers, groups } = user;
  if (contacts) {
    commit('setContacts', contacts);
  }
  if (id) {
    commit('setId', id);
  }
  if (accountId) {
    commit('setAccountId', accountId);
  }
  if (firstName) {
    commit('setFirstName', firstName);
  }
  if (lastName) {
    commit('setLastName', lastName);
  }
  if (email) {
    commit('setEmail', email);
  }
  if (enterpriseId) {
    commit('setEnterpriseId', enterpriseId);
  }
  if (numbers) {
    commit('setNumbers', numbers.map(num => new SmsNumber(num)));
    if (!state.activeNumber) {
      let num = numbers.find(n => n.active === true);
      if (num) {
        commit('setActiveNumber', new SmsNumber(num));
      }
    }
  }
  if (groups) {
    commit('setGroups', groups);
  }
};

const updateBlockedNumbers = ({ commit, getters }, message) => {
  const updatedActiveNumber = getters.activeNumber;
  const numberIndex = updatedActiveNumber.stopRequests.findIndex(n => n.fromNumber === message.from);
  if (message.flowType === 'STOP' || message.flowType === 'OPT_OUT') {
    if (numberIndex >= 0) {
      updatedActiveNumber.stopRequests[numberIndex].stopDate = Date.now();
    } else {
      updatedActiveNumber.stopRequests.push({ fromNumber: message.from, restartDate: null, stopDate: Date.now() });
    }
  } else if (message.flowType === 'UNSTOP' || message.flowType === 'OPT_IN') {
    if (numberIndex >= 0) {
      updatedActiveNumber.stopRequests[numberIndex].restartDate = Date.now();
    }
  }
  commit('setActiveNumber', updatedActiveNumber);
};

const unregisterUser = ({ commit }) => {
  commit('unregisterUser');
};

export default {
  updateBlockedNumbers,
  setUser,
  updateUser,
  unregisterUser
};
